import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCasosRead, postEnviarInformeManual, postCasosAforo, getServiciosAdicionales, postServiciosAdicionales } from "../../helpers/backend";
import Loader from "../../components/Common/Loader";
import ButtonVolver from "../../components/ButtonVolver";
import ActaVisita from './ActaVisita';
import { openActaVisitaPDF } from '../../components/ActaVisitaPDF';
import AforoForm from './AforoForm';
import Swal from 'sweetalert2';
import ServiciosAdicionales from './ServiciosAdicionales';

const ActaVisitaPage = () => {
  const { id } = useParams();
  const [caso, setCaso] = useState({});
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showAforoForm, setShowAforoForm] = useState(false);
  const [activeTab, setActiveTab] = useState('1'); // Estado para las pestañas
  const [serviciosAdicionales, setServiciosAdicionales] = useState([]);
  const [loadingServicios, setLoadingServicios] = useState(false);
  const [showServicioForm, setShowServicioForm] = useState(false);
  const [selectedServicio, setSelectedServicio] = useState(null);
  const theme = useSelector((state) => state.theme.theme) || "light";

  const getCasoData = async () => {
    try {
      setLoading(true);
      const response = await getCasosRead(id);
      const data = response.data;
      setCaso(data);
    } catch (error) {
      console.error('Error al cargar el caso:', error);
    } finally {
      setLoading(false);
    }
  };

  // Función para cargar servicios adicionales
  const getServiciosAdicionalesData = async () => {
    try {
      setLoadingServicios(true);
      const response = await getServiciosAdicionales();
      console.log(response.data.results || []);

      setServiciosAdicionales(response.data.results || []);
    } catch (error) {
      console.error('Error al cargar servicios adicionales:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar los servicios adicionales',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setLoadingServicios(false);
    }
  };


  useEffect(() => {
    getCasoData();
    getServiciosAdicionalesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  // Función para abrir PDF personalizado
  const openPdf = async () => {
    try {
      // Mostrar loading
      Swal.fire({
        title: 'Generando PDF...',
        text: 'Por favor espera mientras se genera el documento',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Obtener datos del informe
      const informe = caso.informe || {};

      // Preparar datos para el PDF
      const actaData = {
        // Información básica
        sin_firma: informe.sin_firma || false, // Agregada validación de sin_firma
        // Usar fecha del backend como fuente principal; si no existe, hoy
        fecha_visita: (informe.fecha_informe || informe.fecha_visita || (() => {
          const hoy = new Date();
          const y = hoy.getFullYear();
          const m = String(hoy.getMonth() + 1).padStart(2, '0');
          const d = String(hoy.getDate()).padStart(2, '0');
          return `${y}-${m}-${d}`;
        })()),
        hora_visita: informe.hora_visita || new Date().toTimeString().slice(0, 5),
        ciudad_visita: informe.ciudad_visita || 'Bogotá',
        // Derivar partes de fecha desde fecha_informe/fecha_visita si faltan los campos separados
        dia_visita: (() => {
          if (informe.dia_visita) return informe.dia_visita;
          const fuente = informe.fecha_informe || informe.fecha_visita;
          let base = null;
          if (fuente) {
            if (/^\d{4}-\d{2}-\d{2}$/.test(fuente)) {
              const [yy, mm, dd] = fuente.split('-');
              base = new Date(Number(yy), Number(mm) - 1, Number(dd));
            } else if (fuente.includes('/')) {
              const soloFecha = fuente.split(' ')[0];
              const [p1, p2, yy] = soloFecha.split('/');
              const tent1 = new Date(Number(yy), Number(p2) - 1, Number(p1));
              const tent2 = new Date(Number(yy), Number(p1) - 1, Number(p2));
              base = isNaN(tent1.getTime()) ? tent2 : tent1;
            }
          }
          const hoy = base || new Date();
          return hoy.getDate().toString();
        })(),
        mes_visita: (() => {
          if (informe.mes_visita) return informe.mes_visita;
          const fuente = informe.fecha_informe || informe.fecha_visita;
          let base = null;
          if (fuente) {
            if (/^\d{4}-\d{2}-\d{2}$/.test(fuente)) {
              const [yy, mm, dd] = fuente.split('-');
              base = new Date(Number(yy), Number(mm) - 1, Number(dd));
            } else if (fuente.includes('/')) {
              const soloFecha = fuente.split(' ')[0];
              const [p1, p2, yy] = soloFecha.split('/');
              const tent1 = new Date(Number(yy), Number(p2) - 1, Number(p1));
              const tent2 = new Date(Number(yy), Number(p1) - 1, Number(p2));
              base = isNaN(tent1.getTime()) ? tent2 : tent1;
            }
          }
          const hoy = base || new Date();
          return hoy.toLocaleDateString('es-ES', { month: 'long' });
        })(),
        año_visita: (() => {
          if (informe.año_visita) return informe.año_visita;
          const fuente = informe.fecha_informe || informe.fecha_visita;
          let base = null;
          if (fuente) {
            if (/^\d{4}-\d{2}-\d{2}$/.test(fuente)) {
              const [yy, mm, dd] = fuente.split('-');
              base = new Date(Number(yy), Number(mm) - 1, Number(dd));
            } else if (fuente.includes('/')) {
              const soloFecha = fuente.split(' ')[0];
              const [p1, p2, yy] = soloFecha.split('/');
              const tent1 = new Date(Number(yy), Number(p2) - 1, Number(p1));
              const tent2 = new Date(Number(yy), Number(p1) - 1, Number(p2));
              base = isNaN(tent1.getTime()) ? tent2 : tent1;
            }
          }
          const hoy = base || new Date();
          return hoy.getFullYear().toString();
        })(),
        archivo_no: informe.archivo_no || '',
        no_pqrs: informe.no_de_pqrs || caso.numero_reclamo || '',
        cuenta_suscriptor: informe.cuenta_suscriptor || '',
        cuenta_energia: informe.cuenta_energia || '',
        direccion: informe.direccion || caso.cliente?.[0].address?.[0].address || '',

        // Datos del predio
        direccion_predio: informe.direccion_predio || '',
        estrato_predio: informe.estrato_predio || '',
        localidad_predio: informe.localidad_predio || '',
        actualizacion_nombre_suscriptor: informe.actualizacion_nombre_suscriptor || '',

        // Tablas dinámicas
        unidades_residenciales_detalle: informe.unidades_residenciales_detalle ?
          (typeof informe.unidades_residenciales_detalle === 'string' ?
            JSON.parse(informe.unidades_residenciales_detalle) :
            informe.unidades_residenciales_detalle) : [],
        producto_nombre: informe.producto_nombre || '',
        producto_detalle: informe.producto_detalle ?
          (typeof informe.producto_detalle === 'string' ?
            JSON.parse(informe.producto_detalle) :
            informe.producto_detalle) : [],
        unidades_no_residenciales_detalle: informe.unidades_no_residenciales_detalle ?
          (typeof informe.unidades_no_residenciales_detalle === 'string' ?
            JSON.parse(informe.unidades_no_residenciales_detalle) :
            informe.unidades_no_residenciales_detalle) : [],
        producto_unr: informe.producto_unr || '',
        recipientes_detalle: informe.recipientes_detalle ?
          (typeof informe.recipientes_detalle === 'string' ?
            JSON.parse(informe.recipientes_detalle) :
            informe.recipientes_detalle) : [],

        // Características del predio
        abandonado: informe.abandonado || false,
        suscriptor_inactivo: informe.suscriptor_inactivo || false,
        demolido: informe.demolido || false,
        en_construccion: informe.en_construccion || false,
        en_remodelacion: informe.en_remodelacion || false,
        inexistente: informe.inexistente || false,
        inhabitable_o_en_ruinas: informe.inhabitable_o_en_ruinas || false,
        lote: informe.lote || false,
        minimas_condiciones: informe.minimas_condiciones || false,
        programa_del_icbf: informe.programa_del_icbf || false,
        descuento_puerta_a_puerta: informe.descuento_puerta_a_puerta || false,
        se_cierra_pqr_como_no_atendido: informe.se_cierra_pqr_como_no_atendido || false,
        areas_comunes: informe.areas_comunes || false,
        predio_que_se_observa_vacio: informe.predio_que_se_observa_vacio || false,
        predio_se_observa_ocupado: informe.predio_se_observa_ocupado || false,
        cuenta_suscriptor_activo: informe.cuenta_suscriptor_activo || false,
        causa_demolicion: informe.causa_demolicion || "",
        suscriptor_activo_detalles: informe.suscriptor_activo_detalles || "",


        // Tipos de residuos
        tipos_residuos: {
          escombros: informe.escombros || false,
          especiales: informe.especiales || false,
          para_reuso: informe.para_relleno || false,
          para_escombrera: informe.para_escombrera || false,
          enlonado: informe.enlonado || false,
          a_granel: informe.a_granel || false
        },
        tipo_recoleccion: informe.tipo_recoleccion || '',
        m3_gratis: informe.m3_gratis || false,
        dos_m3_gratis: (informe.dos_m3_gratis ?? informe['2m3_gratis']) || false,
        valor_m3: informe.valor_m3 || '',
        cancelado: informe.cancelado || false,

        // Observaciones y representantes
        observaciones: informe.observaciones || '',
        nombre_cliente: informe.nombre_cliente || '',
        direccion_informe: caso.informes_adicionales[0]?.direccion_informe || '',
        representante_nombre: informe.representante_nombre || '',
        representante_cedula: informe.representante_cedula || '',
        representante_firma: informe.representante_firma,
        representante_telefono_celular: informe.representante_telefono_celular || '',
        ciudad_limpia_nombre: informe.ciudad_limpia_nombre || '',
        ciudad_limpia_telefono: informe.ciudad_limpia_telefono || '',
        ciudad_limpia_codigo: informe.ciudad_limpia_codigo || '',
        ciudad_limpia_firma: informe.ciudad_limpia_firma || '',
        anotaciones: informe.anotaciones || ''

      };

      // Debug: Verificar datos de informes adicionales
      console.log('Caso completo:', caso);
      console.log('Informes adicionales:', caso.informes_adicionales);
      console.log('Cantidad de informes adicionales:', caso.informes_adicionales?.length || 0);

      // Debug: Verificar qué se está pasando exactamente a openActaVisitaPDF
      const informesAdicionales = caso.informes_adicionales || [];
      console.log('Informes adicionales que se pasarán al PDF:', informesAdicionales);
      console.log('Tipo de informes adicionales:', typeof informesAdicionales);
      console.log('Es array:', Array.isArray(informesAdicionales));

      // Generar y abrir PDF
      const result = await openActaVisitaPDF(actaData, caso, informesAdicionales);

      Swal.close();

      if (!result.success) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF. Por favor intenta nuevamente.',
          confirmButtonColor: '#dc3545'
        });
      }
    } catch (error) {
      console.error('Error al generar PDF:', error);
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al generar el PDF. Por favor intenta nuevamente.',
        confirmButtonColor: '#dc3545'
      });
    }
  };

  // Función para mostrar formulario
  const openForm = () => {
    setShowForm(true);
  };

  // Función para volver a la vista de opciones
  const backToOptions = () => {
    setShowForm(false);
  };

  // Función para cambiar pestañas
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // Función para crear aforo
  const handleCrearAforo = async () => {
    const { value: formData } = await Swal.fire({
      title: 'Crear Aforo',
      html: `
        <div style="text-align: left; margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500; color: #495057;">Total de Semanas *</label>
          <input 
            id="total-semanas" 
            type="number" 
            min="1"
            max="52"
            placeholder="Ingrese el total de semanas"
            style="width: 100%; padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px; outline: none; font-size: 14px;"
          />
        </div>
        <div style="text-align: left; margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500; color: #495057;">Total de Frecuencia *</label>
          <input 
            id="total-frecuencia" 
            type="number" 
            min="1"
            max="7"
            placeholder="Ingrese el total de frecuencia"
            style="width: 100%; padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px; outline: none; font-size: 14px;"
          />
        </div>
        <div style="text-align: left; font-size: 12px; color: #6c757d; margin-top: 10px;">
          <i class="fas fa-info-circle"></i> Ambos campos son obligatorios para crear el aforo
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Crear Aforo',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      focusConfirm: false,
      preConfirm: () => {
        const totalSemanas = document.getElementById('total-semanas').value;
        const totalFrecuencia = document.getElementById('total-frecuencia').value;

        if (!totalSemanas || !totalFrecuencia) {
          Swal.showValidationMessage('Todos los campos son obligatorios');
          return false;
        }

        const semanas = parseInt(totalSemanas);
        const frecuencia = parseInt(totalFrecuencia);

        if (isNaN(semanas) || semanas < 1 || semanas > 52) {
          Swal.showValidationMessage('El total de semanas debe ser un número entre 1 y 52');
          return false;
        }

        if (isNaN(frecuencia) || frecuencia < 1 || frecuencia > 7) {
          Swal.showValidationMessage('El total de frecuencia debe ser un número entre 1 y 7');
          return false;
        }

        return {
          total_semana: semanas,
          total_frecuencia: frecuencia
        };
      }
    });

    if (formData) {
      try {
        const response = await postCasosAforo(id, formData);
        if (response) {
          Swal.fire({
            title: 'Éxito',
            text: 'Aforo creado exitosamente',
            icon: 'success',
            confirmButtonText: 'OK'
          });
          // Recargar datos del caso para mostrar el formulario de aforo
          getCasoData();
        }
      } catch (error) {
        console.error('Error creando aforo:', error);
        Swal.fire({
          title: 'Error',
          text: 'No se pudo crear el aforo. Intenta nuevamente.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  };

  // Función para cerrar formulario de aforo
  const handleCloseAforoForm = () => {
    setShowAforoForm(false);
    // Recargar datos del caso para mostrar cambios
    getCasoData();
  };

  // Función para enviar informe
  const handleEnviarInforme = async () => {
    const { value: formData } = await Swal.fire({
      title: "Enviar Informe",
      html: `
        <div style="text-align: left; margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 500; color: #495057;">Número de teléfono</label>
          <div style="display: flex; border: 1px solid #ced4da; border-radius: 4px; overflow: hidden;">
            <select 
              id="country-select" 
              style="padding: 8px; border: none; background: #f8f9fa; border-right: 1px solid #ced4da; outline: none;"
            >
              <option value="+57">🇨🇴 +57</option>
              <option value="+1">🇺🇸 +1</option>
              <option value="+52">🇲🇽 +52</option>
              <option value="+34">🇪🇸 +34</option>
              <option value="+54">🇦🇷 +54</option>
              <option value="+56">🇨🇱 +56</option>
              <option value="+51">🇵🇪 +51</option>
              <option value="+58">🇻🇪 +58</option>
              <option value="+593">🇪🇨 +593</option>
              <option value="+591">🇧🇴 +591</option>
            </select>
            <input 
              id="phone-input" 
              type="tel" 
              placeholder="300 123 4567"
              style="flex: 1; padding: 8px 12px; border: none; outline: none; font-size: 14px;"
            />
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      didOpen: () => {
        const phoneInput = document.getElementById('phone-input');
        const countrySelect = document.getElementById('country-select');

        // Función para formatear el número
        const formatPhoneNumber = (value) => {
          const numbers = value.replace(/\D/g, '');
          if (numbers.length <= 3) return numbers;
          if (numbers.length <= 6) return numbers.slice(0, 3) + ' ' + numbers.slice(3);
          return numbers.slice(0, 3) + ' ' + numbers.slice(3, 6) + ' ' + numbers.slice(6, 10);
        };

        // Event listener para formatear mientras se escribe
        phoneInput.addEventListener('input', (e) => {
          const formatted = formatPhoneNumber(e.target.value);
          e.target.value = formatted;
        });
      },
      preConfirm: () => {
        const countryCode = document.getElementById('country-select').value;
        const phoneNumber = document.getElementById('phone-input').value;

        if (!phoneNumber.trim()) {
          Swal.showValidationMessage('El número de teléfono es obligatorio');
          return false;
        }

        const numbersOnly = phoneNumber.replace(/\D/g, '');
        if (numbersOnly.length < 7 || numbersOnly.length > 15) {
          Swal.showValidationMessage('Ingrese un número de teléfono válido (7-15 dígitos)');
          return false;
        }

        return {
          countryCode: countryCode,
          phoneNumber: numbersOnly,
          fullNumber: countryCode + numbersOnly
        };
      }
    });

    if (formData) {
      try {
        const response = await postEnviarInformeManual({
          phone: formData.fullNumber,
          caso_id: caso.id
        });
        console.log(formData.fullNumber);

        if (response.status === 200) {
          Swal.fire({
            title: "¡Informe Enviado!",
            text: `El informe ha sido enviado exitosamente al ` + formData.fullNumber,
            icon: "success",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#28a745",
          });
        } else {
          throw new Error('Error en la respuesta del servidor');
        }
      } catch (error) {
        console.error("Error al enviar informe:", error);
        Swal.fire({
          title: "Error",
          text: error.data.error,
          icon: "error",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#dc3545"
        });
      }
    }
  };

  // Función para seleccionar un servicio y mostrar el formulario
  const handleSelectServicio = (servicio) => {
    setSelectedServicio(servicio);
    setShowServicioForm(true);
  };

  // Función para agregar servicio adicional al caso
  const handleAgregarServicio = async (formData) => {
    try {
      const response = await postServiciosAdicionales(id, {
        servicio_id: selectedServicio.id,
        rango_generacion_mensual: formData.rango_generacion_mensual,
        proveedor_actual: formData.proveedor_actual
      });

      if (response) {
        Swal.fire({
          title: 'Éxito',
          text: 'Servicio adicional agregado exitosamente',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#28a745'
        });
        setShowServicioForm(false);
        setSelectedServicio(null);
        // Recargar datos del caso para mostrar el servicio agregado
        getCasoData();
      }
    } catch (error) {
      console.error('Error agregando servicio:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo agregar el servicio. Intenta nuevamente.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#dc3545'
      });
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Ciudad Limpia | Acta de Visita - {caso.name}</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card style={{
                backgroundColor: theme === 'dark' ? '#2a3042' : '#ffffff',
                border: theme === 'dark' ? '1px solid #404954' : '1px solid #dee2e6'
              }}>
                <CardBody>
                  {/* Header con botón volver */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                      <ButtonVolver />
                      <div className="ms-3">
                        <h4 className="mb-1" style={{
                          color: theme === 'dark' ? '#adb5bd' : '#495057',
                          fontSize: '20px'
                        }}>
                          <i className="fas fa-clipboard-list me-2" style={{ color: '#556ee6' }}></i>
                          Gestión de OT
                        </h4>
                        <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                          {caso.name ? caso.name.replace(/^Caso\s/, 'OT ') : ''} - {caso.tipo_caso}
                        </p>
                        <div className="d-flex flex-wrap gap-3 mt-1">
                          <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                            <strong>Reclamo:</strong> {caso?.numero_reclamo || 'N/A'}
                          </p>
                          {caso?.cliente?.[0]?.address?.[0]?.address && (
                            <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                              <i className="fas fa-map-marker-alt me-1 text-primary"></i>
                              <strong>Dirección:</strong> {caso.cliente[0].address[0].address}
                            </p>
                          )}
                        </div>
                        <div className="d-flex flex-wrap gap-3 mt-1">
                          {caso?.cliente?.[0]?.catastros_ciudad_limpia?.[0]?.cuenta_contrato && (
                            <span className="badge bg-soft-info text-info font-size-12 p-2" style={{ backgroundColor: 'rgba(80, 165, 241, 0.1)' }}>
                              <i className="fas fa-file-invoice me-1"></i>
                              Cta. Contrato: {caso.cliente[0].catastros_ciudad_limpia[0].cuenta_contrato}
                            </span>
                          )}
                          {caso?.cliente?.[0]?.catastros_enel?.[0]?.nro_cuenta && (
                            <span className="badge bg-soft-warning text-warning font-size-12 p-2" style={{ backgroundColor: 'rgba(241, 180, 76, 0.1)' }}>
                              <i className="fas fa-bolt me-1"></i>
                              Cta. Enel: {caso.cliente[0].catastros_enel[0].nro_cuenta}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Pestañas de navegación */}
                  <Nav tabs className="mb-4">
                    <NavItem>
                      <NavLink
                        className={activeTab === '1' ? 'active' : ''}
                        onClick={() => toggleTab('1')}
                        style={{
                          cursor: 'pointer',
                          color: activeTab === '1' ? '#556ee6' : (theme === 'dark' ? '#adb5bd' : '#6c757d'),
                          borderColor: activeTab === '1' ? '#556ee6' : 'transparent',
                          backgroundColor: activeTab === '1' ? (theme === 'dark' ? '#2a3042' : '#f8f9fa') : 'transparent'
                        }}
                      >
                        <i className="fas fa-clipboard-list me-2"></i>
                        Acta de Visita
                      </NavLink>
                    </NavItem>
                    {/* Solo mostrar la pestaña de Aforo si tipo_caso no es ESCOMBROS */}
                    {caso.tipo_caso !== 'ESCOMBROS' && (
                      <NavItem>
                        <NavLink
                          className={activeTab === '2' ? 'active' : ''}
                          onClick={() => toggleTab('2')}
                          style={{
                            cursor: 'pointer',
                            color: activeTab === '2' ? '#556ee6' : (theme === 'dark' ? '#adb5bd' : '#6c757d'),
                            borderColor: activeTab === '2' ? '#556ee6' : 'transparent',
                            backgroundColor: activeTab === '2' ? (theme === 'dark' ? '#2a3042' : '#f8f9fa') : 'transparent'
                          }}
                        >
                          <i className="fas fa-calculator me-2"></i>
                          Aforo
                        </NavLink>
                      </NavItem>
                    )}
                    {/* Pestaña de Servicios Adicionales */}
                    <NavItem>
                      <NavLink
                        className={activeTab === '3' ? 'active' : ''}
                        onClick={() => toggleTab('3')}
                        style={{
                          cursor: 'pointer',
                          color: activeTab === '3' ? '#556ee6' : (theme === 'dark' ? '#adb5bd' : '#6c757d'),
                          borderColor: activeTab === '3' ? '#556ee6' : 'transparent',
                          backgroundColor: activeTab === '3' ? (theme === 'dark' ? '#2a3042' : '#f8f9fa') : 'transparent'
                        }}
                      >
                        <i className="fas fa-cogs me-2"></i>
                        Servicios Adicionales
                      </NavLink>
                    </NavItem>
                  </Nav>

                  {/* Contenido de las pestañas */}
                  <TabContent activeTab={activeTab}>
                    {/* Pestaña Acta de Visita */}
                    <TabPane tabId="1">
                      {caso && Object.keys(caso).length > 0 ? (
                        caso.estado === 'FINALIZADO' && !showForm ? (
                          /* Vista para casos finalizados */
                          <div className="text-center py-5">
                            <div className="mb-5">
                              {/* Ícono principal con gradiente */}
                              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                  color: 'white',
                                  boxShadow: '0 8px 25px rgba(40, 167, 69, 0.3)'
                                }}>
                                <i className="fas fa-check-circle" style={{ fontSize: '45px' }}></i>
                              </div>

                              <h2 className="mb-3 fw-bold" style={{
                                color: theme === 'dark' ? '#adb5bd' : '#2c3e50',
                                fontSize: '28px'
                              }}>
                                OT Finalizada
                              </h2>

                              <p className="text-muted mb-5" style={{
                                fontSize: '16px',
                                maxWidth: '500px',
                                margin: '0 auto',
                                lineHeight: '1.6'
                              }}>
                                Esta OT ha sido completado exitosamente. Selecciona una opción para continuar:
                              </p>
                            </div>

                            {/* Contenedor de botones mejorado */}
                            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-4">
                              {/* Botón Formulario */}
                              <div className="text-center">
                                <Button
                                  color="primary"
                                  onClick={openForm}
                                  className="d-flex flex-column align-items-center justify-content-center p-4"
                                  style={{
                                    width: '120px',
                                    height: '90px',
                                    borderRadius: '12px',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #556ee6 0%, #7c69ef 100%)',
                                    boxShadow: '0 6px 20px rgba(85, 110, 230, 0.3)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 10px 30px rgba(85, 110, 230, 0.4)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(85, 110, 230, 0.3)';
                                  }}
                                >
                                  <i className="fas fa-edit mb-1" style={{ fontSize: '20px' }}></i>
                                  <span style={{ fontSize: '12px', fontWeight: '600' }}>Abrir</span>
                                  <span style={{ fontSize: '12px', fontWeight: '600' }}>Formulario</span>
                                </Button>
                              </div>

                              {/* Botón PDF */}
                              <div className="text-center">
                                <Button
                                  color="danger"
                                  onClick={openPdf}
                                  className="d-flex flex-column align-items-center justify-content-center p-4"
                                  style={{
                                    width: '120px',
                                    height: '90px',
                                    borderRadius: '12px',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)',
                                    boxShadow: '0 6px 20px rgba(220, 53, 69, 0.3)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 10px 30px rgba(220, 53, 69, 0.4)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(220, 53, 69, 0.3)';
                                  }}
                                >
                                  <i className="fas fa-file-pdf mb-1" style={{ fontSize: '24px' }}></i>
                                  <span style={{ fontSize: '12px', fontWeight: '600' }}>Abrir</span>
                                  <span style={{ fontSize: '12px', fontWeight: '600' }}>PDF</span>
                                </Button>
                              </div>

                              {/* Botón Enviar Acta */}
                              <div className="text-center">
                                <Button
                                  color="success"
                                  onClick={handleEnviarInforme}
                                  className="d-flex flex-column align-items-center justify-content-center p-4"
                                  style={{
                                    width: '120px',
                                    height: '90px',
                                    borderRadius: '12px',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                    boxShadow: '0 6px 20px rgba(40, 167, 69, 0.3)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 10px 30px rgba(40, 167, 69, 0.4)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(40, 167, 69, 0.3)';
                                  }}
                                >
                                  <i className="fas fa-paper-plane mb-1" style={{ fontSize: '20px' }}></i>
                                  <span style={{ fontSize: '12px', fontWeight: '600' }}>Enviar</span>
                                  <span style={{ fontSize: '12px', fontWeight: '600' }}>Acta</span>
                                </Button>
                              </div>
                            </div>

                            {/* Información adicional */}
                            <div className="mt-4">
                              <small className="text-muted" style={{ fontSize: '12px' }}>
                                💡 Tip: El formulario te permite revisar todos los detalles, mientras que el PDF es ideal para imprimir o compartir.
                              </small>
                            </div>
                          </div>
                        ) : (
                          /* Vista del formulario */
                          <div>
                            {caso.estado === 'FINALIZADO' && showForm && (
                              <div className="mb-3">
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={backToOptions}
                                  className="d-flex align-items-center"
                                >
                                  <i className="fas fa-arrow-left me-2"></i>
                                  Volver a opciones
                                </Button>
                              </div>
                            )}
                            <ActaVisita caso={caso} theme={theme} />
                          </div>
                        )
                      ) : (
                        <div className="text-center py-5">
                          <p style={{ color: theme === 'dark' ? '#adb5bd' : '#6c757d' }}>
                            No se pudo cargar la información del caso
                          </p>
                        </div>
                      )}
                    </TabPane>

                    {/* Pestaña Aforo - Solo mostrar si tipo_caso no es ESCOMBROS */}
                    {caso.tipo_caso !== 'ESCOMBROS' && (
                      <TabPane tabId="2">
                        {caso && Object.keys(caso).length > 0 ? (
                          /* Mostrar formulario de aforo si existe, o mensaje bonito si no existe */
                          caso.aforos && caso.aforos.length > 0 ? (
                            /* AforoForm ocupando toda la pestaña */
                            <AforoForm
                              casoId={id}
                              caso={caso}
                              onClose={() => {/* No necesita cerrar ya que está integrado */ }}
                              onSuccess={() => {
                                Swal.fire({
                                  title: 'Éxito',
                                  text: 'Visita de aforo guardada exitosamente',
                                  icon: 'success',
                                  confirmButtonText: 'OK'
                                });
                                getCasoData();
                              }}
                            />
                          ) : (
                            /* Vista cuando no existe aforo - Mensaje bonito */
                            <div className="text-center py-5">
                              <div className="mb-5">
                                {/* Ícono principal con gradiente */}
                                <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                                  style={{
                                    width: '120px',
                                    height: '120px',
                                    background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                    color: 'white',
                                    boxShadow: '0 10px 30px rgba(23, 162, 184, 0.3)'
                                  }}>
                                  <i className="fas fa-calculator" style={{ fontSize: '50px' }}></i>
                                </div>

                                <h3 className="mb-3 fw-bold" style={{
                                  color: theme === 'dark' ? '#adb5bd' : '#2c3e50',
                                  fontSize: '24px'
                                }}>
                                  Aforo no Creado
                                </h3>

                                <p className="text-muted mb-5" style={{
                                  fontSize: '16px',
                                  maxWidth: '600px',
                                  margin: '0 auto 2rem auto',
                                  lineHeight: '1.6'
                                }}>
                                  Aún no existe un aforo para esta OT. El aforo te permitirá registrar las visitas de medición y control de residuos.
                                  <br /><strong>¡Crea uno ahora para comenzar!</strong>
                                </p>
                              </div>

                              {/* Botón mejorado para crear aforo */}
                              <div className="d-flex justify-content-center">
                                <Button
                                  color="info"
                                  onClick={handleCrearAforo}
                                  className="d-flex align-items-center px-4 py-3"
                                  style={{
                                    borderRadius: '25px',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                    boxShadow: '0 8px 25px rgba(23, 162, 184, 0.3)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: 'white'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                    e.currentTarget.style.boxShadow = '0 12px 35px rgba(23, 162, 184, 0.4)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(23, 162, 184, 0.3)';
                                  }}
                                >
                                  <i className="fas fa-plus-circle me-2" style={{ fontSize: '18px', color: 'white' }}></i>
                                  Crear Aforo
                                </Button>
                              </div>

                              {/* Información adicional */}
                              <div className="mt-4 p-3 rounded" style={{
                                backgroundColor: theme === 'dark' ? '#2a3042' : '#f8f9fa',
                                border: `1px solid ${theme === 'dark' ? '#404954' : '#e9ecef'}`,
                                maxWidth: '500px',
                                margin: '2rem auto 0 auto'
                              }}>
                                <small className="text-muted d-block mb-2" style={{ fontSize: '14px' }}>
                                  <i className="fas fa-info-circle me-2" style={{ color: '#17a2b8' }}></i>
                                  <strong>¿Qué es un aforo?</strong>
                                </small>
                                <small className="text-muted" style={{ fontSize: '13px', lineHeight: '1.4' }}>
                                  El aforo es un registro sistemático de visitas para medir y controlar la producción de residuos,
                                  permitiendo un seguimiento detallado de la orden de trabajo.
                                </small>
                              </div>
                            </div>
                          )
                        ) : (
                          <div className="text-center py-5">
                            <p style={{ color: theme === 'dark' ? '#adb5bd' : '#6c757d' }}>
                              No se pudo cargar la información del caso
                            </p>
                          </div>
                        )}
                      </TabPane>
                    )}

                    {/* Pestaña Servicios Adicionales */}
                    <TabPane tabId="3">
                      <ServiciosAdicionales
                        theme={theme}
                        servicios={serviciosAdicionales}
                        loading={loadingServicios}
                        showForm={showServicioForm}
                        selectedServicio={selectedServicio}
                        onSelectServicio={handleSelectServicio}
                        onAgregarServicio={handleAgregarServicio}
                        onCancel={() => { setShowServicioForm(false); setSelectedServicio(null); }}
                        serviciosYaAgregados={Array.isArray(caso?.servicios_adicionales) ? caso.servicios_adicionales : []}
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Modal/Formulario de Aforo */}
      {showAforoForm && (
        <AforoForm
          casoId={id}
          casoData={caso}
          onClose={handleCloseAforoForm}
          onSuccess={() => {
            handleCloseAforoForm();
            Swal.fire({
              icon: 'success',
              title: '¡Aforo Guardado!',
              text: 'Las visitas de aforo han sido guardadas exitosamente',
              confirmButtonColor: '#28a745'
            });
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ActaVisitaPage;